import {useState, useCallback, useRef} from "react";

export const useCopyID = () => {
    const [copiedID, setCopiedID] = useState<string | null>(null);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const copyID = useCallback((id: string) => {
        navigator.clipboard.writeText(id).then(() => {
            setCopiedID(id);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => setCopiedID(null), 2000);
        });
    }, []);

    const isCopied = useCallback((id: string) => copiedID === id, [copiedID]);

    return {copyID, isCopied};
};
